import { render, staticRenderFns } from "./ProductBanner.vue?vue&type=template&id=0de2cae4&scoped=true"
import script from "./ProductBanner.vue?vue&type=script&lang=ts"
export * from "./ProductBanner.vue?vue&type=script&lang=ts"
import style0 from "./ProductBanner.vue?vue&type=style&index=0&id=0de2cae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de2cae4",
  null
  
)

export default component.exports